(ns ui.editors.card.model
  (:require [ui.util :as uu]
            [common.localization :as loc]
            [clojure.string :as string]
            [common.schema.entities.card :as card-schema]))

(def root-path [::state])

(def initialized-path [:initialized?])
(def initialized-full-path (vec (concat root-path initialized-path)))

(def open-path [:open?])
(def open-full-path (vec (concat root-path open-path)))

(def show-modal-path [:show-modal?])
(def show-modal-full-path (vec (concat root-path show-modal-path)))

(def card-path [:card])
(def card-config-path (conj card-path :card/config))
(def card-config-full-path (vec (concat root-path card-path [:card/config])))
(def card-full-path (vec (concat root-path card-path)))

(def original-card-path [:original-card])
(def original-card-full-path (vec (concat root-path original-card-path)))

(def current-tab-path [:current-tab])
(def current-tab-full-path (vec (concat root-path current-tab-path)))

(def submitting-path [:submitting?])
(def submitting-full-path (vec (concat root-path submitting-path)))

(def create-new-card-path [:create-new-card?])
(def create-new-card-full-path (vec (concat root-path create-new-card-path)))

(def update-card-path [:update-card?])
(def update-card-full-path (vec (concat root-path update-card-path)))

(def entity-type-path [:entity-type])
(def entity-type-full-path (vec (concat root-path entity-type-path)))

(def preview-card-default-width-path [:preview-card-default-width])
(def preview-card-state-path [:preview-card-state])
(def preview-entity-id-path [:preview-entity-id])

(def validation-error-path [:validation-error])
(def validation-error-full-path (vec (concat root-path validation-error-path)))

(def preview-entity-id-full-path (vec (concat root-path preview-entity-id-path)))
(def preview-card-state-full-path (vec (concat root-path preview-card-state-path)))

(def close-editor-callback-event-path [:close-editor-callback-event])
(def close-editor-callback-event-full-path (vec (concat root-path close-editor-callback-event-path)))

(defn initialize-editor
  [db {:keys [card card-temp-id card-type entity-type
              preview-entity-id account-id
              create-new-card? update-card?
              preview-card-default-width
              close-editor-callback-event]}]
  (let [card (if create-new-card?
               (card-schema/default-card {:temp-id card-temp-id
                                          :card-type card-type
                                          :entity-type entity-type
                                          :account-id account-id
                                          :tr loc/tr})
               card)
        original-card (when-not create-new-card?
                        card)]
    (-> db
        (assoc-in initialized-full-path true)
        (assoc-in open-full-path true)
        (assoc-in card-full-path card)
        (assoc-in original-card-full-path original-card)
        (assoc-in entity-type-full-path entity-type)
        (assoc-in create-new-card-full-path create-new-card?)
        (assoc-in update-card-full-path update-card?)
        (assoc-in current-tab-full-path :editor)
        (assoc-in preview-entity-id-full-path preview-entity-id)
        (assoc-in (conj root-path :preview-card-default-width) preview-card-default-width)
        (assoc-in preview-card-state-full-path {:loading? true
                                                :initial-data-loaded? false})
        (assoc-in close-editor-callback-event-full-path close-editor-callback-event))))

(defn set-current-tab
  [db tab]
  (assoc-in db (concat root-path current-tab-path) tab))

(defn set-card-title
  [db new-title]
  (assoc-in db (concat root-path card-path [:card/title]) new-title))

(defn set-card-description
  [db new-description]
  (assoc-in db (concat root-path card-path [:card/description]) new-description))

(defn select-preview-entity-id
  [db entity-id]
  (-> db
      (assoc-in (concat root-path preview-entity-id-path) entity-id)
      (assoc-in preview-card-state-full-path {:loading? true
                                              :initial-data-loaded? false})))
